export const NOTIFICATIONS_GETTERS = {
  ALL: 'notifications'
}

export const NOTIFICATIONS_ACTIONS = {
  ADD_NOTIFICATION: 'addNotification',
  REMOVE_NOTIFICATION: 'removeNotification',
  REMOVE_ALL_NOTIFICATIONS: 'removeAllNotification'
};

const NOTIFICATIONS_MUTATIONS = {
  ADD_NOTIFICATION: 'addNotification',
  REMOVE_NOTIFICATION: 'removeNotification',
  REMOVE_ALL_NOTIFICATIONS: 'removeAllNotification'
};


export default {
  namespaced: true,
  state: {
    notifications: [],
  },
  getters: {
    [NOTIFICATIONS_GETTERS.ALL]: (state) => {
      state.notifications.slice().reverse();
    }
  },
  mutations: {
    [NOTIFICATIONS_MUTATIONS.ADD_NOTIFICATION]: (state, notification) => {
      state.notifications.unshift({...notification, time: new Date()})
    },
    [NOTIFICATIONS_MUTATIONS.REMOVE_NOTIFICATION]: (state, notification) =>
      state.notifications.splice(state.notifications.indexOf(notification), 1),
    [NOTIFICATIONS_MUTATIONS.REMOVE_ALL_NOTIFICATIONS]: (state) => {
      state.notifications = [];
    },
  },
  actions: {
    [NOTIFICATIONS_ACTIONS.ADD_NOTIFICATION]: ({commit}, notification) => {
      commit(NOTIFICATIONS_MUTATIONS.ADD_NOTIFICATION, notification)
    },
    [NOTIFICATIONS_ACTIONS.REMOVE_NOTIFICATION]: ({commit}, notification) => {
      commit(NOTIFICATIONS_MUTATIONS.REMOVE_NOTIFICATION, notification)
    },
    [NOTIFICATIONS_ACTIONS.REMOVE_ALL_NOTIFICATIONS]: ({commit}) => {
      commit(NOTIFICATIONS_MUTATIONS.REMOVE_ALL_NOTIFICATIONS)
    },
  },
};
